import { useCallback, useContext, useMemo, useState } from 'react';
import Modal from '../modal/Modal';
import UserContext, { WarehouseContext } from '../../common/utils/getContext';
import T from '../../common/components/T';
import css from './PaymasterModal.module.scss';
import FormComponent from '../form/FormComponent/FormComponent';
import { getFormFields, setFormDataFunc } from './helpers';
import { dataSender } from '../../common/utils/router';

const PaymasterModal = ({ paymasterModal }) => {
    const { setState } = useContext(WarehouseContext);
    const { userToken, lang, setAlertData } = useContext(UserContext);

    const [formData, setFormData] = useState({
        payment_type: 0,
        currency: paymasterModal?.order?.currency?.code
    });

    const formFields = useMemo(() => {
        return getFormFields(formData, setFormData, paymasterModal);
    }, [formData, paymasterModal]);

    const sender = useCallback(
        (dataToSend, setAllowedSend, setFieldsErr) => {
            dataSender(
                paymasterModal?.link,
                'PATCH',
                {
                    accounts: formData?.accounts?.map((acc) => ({ id: acc.id, amount: acc?.amount }))
                },
                () => {
                    if (typeof paymasterModal?.onSuccess === 'function') {
                        paymasterModal?.onSuccess();
                    }
                    setState('paymasterModal', false);
                },
                (data) => {
                    setAllowedSend(true);
                    if (data.errors && Object.keys(data.errors).length) {
                        setFieldsErr(data.errors);
                    }
                    setAlertData({
                        type: 'error',
                        cont: data?.message || <T textName='error_occured' defaultStr='Произошла ошибка' />
                    });
                },
                userToken,
                lang
            );
        },
        [userToken, lang, paymasterModal, formData, setAlertData, setState]
    );
    return (
        <Modal closeHandler={() => setState('paymasterModal', false)}>
            <p className={css.title}>
                <T textName={'choosing_a_wallet'} defaultStr={'Выбор кошелька'} />
            </p>
            <FormComponent
                formDataMain={formData}
                setFormDataMain={(k, v) => setFormDataFunc(k, v, setFormData, paymasterModal)}
                data={formFields}
                sendData={{ sender }}
                buttons={[
                    {
                        type: 'cancel',
                        clickFunc: () => setState('paymasterModal', false)
                    },
                    {
                        type: 'ok',
                        buttonText: <T textName='confirm' defaultStr='Подтвердить' />
                    }
                ]}
                customData={{
                    customFormButton: {
                        isFullWidth: true
                    }
                }}
            />
        </Modal>
    );
};

export default PaymasterModal;
